const AUTHENTICATED_USER_EMAILS = [
	'aoafloorplan@gmail.com',
	'jinkaoa@gmail.com',
	'rockswild71@gmail.com',
	'toddviani@gmail.com',
]

const BOOTH_LAYOUT = {
	borderWidth: 2,
	columns: 18,
	dimension: 60,
	rows: 26,
}

const FIREBASE_CONFIG = {
	apiKey: 'AIzaSyAQZL7ZitKRPzQalcRtEL-2WFrJhw4f0Dc',
	authDomain: 'tradeshow-floorplan.firebaseapp.com',
	databaseURL: 'https://tradeshow-floorplan.firebaseio.com/',
	projectId: 'tradeshow-floorplan',
	storageBucket: 'gs://tradeshow-floorplan.appspot.com',
}

/**
 * Allows you to create programmatic routes
 * You can pass a custom BOOTH_LAYOUT object for each page if you would like
 * https://www.gatsbyjs.org/docs/bound-action-creators/#createPage
 */
const FLOORPLAN_PAGES = [
	{
		name: 'Los Angeles',
		path: '/la',
		context: Object.assign({}, BOOTH_LAYOUT, { columns: 15, rows: 27 }),
	},
	{
		name: 'Long Beach',
		path: '/lb',
		context: BOOTH_LAYOUT,
	},
]

const USER_MAP = {
	Jin: {
		color: '#ff00aa',
		email: 'jinkaoa@gmail.com',
	},
	Richard: {
		color: '#0800FF',
		email: 'rockswild71@gmail.com',
	},
	Todd: {
		color: '#00B20E',
		email: 'toddviani@gmail.com',
	},
}

module.exports = {
	AUTHENTICATED_USER_EMAILS,
	FIREBASE_CONFIG,
	FLOORPLAN_PAGES,
	USER_MAP,
}



// WEBPACK FOOTER //
// ./config.js